// extracted by mini-css-extract-plugin
export default {"root":"_TK6nboqaRjwTqs0iI9N"};